export default __webpack_public_path__ + "static/media/TL08.b81d7487.mp3";